import React, { useState } from 'react';
import api from '../../http';
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper';
import Button from './Button';
import { ArrowLeft } from 'lucide-react';
import Show from 'Components/Show/Show';

const AccountBlocked = ({ navigateToLogin, email }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleResetPassword = async () => {
    if (!email) return;
    try {
      setLoading(true);
      setError('');
      await api.get(
        `${process.env.REACT_APP_TC_AUTH}/api/Account/SendPasswordResetLink/${email}`
      );
      setEmailSent(true);
    } catch (err) {
      setError(err.response?.data?.responseMessage || 'Failed to send reset link.');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <AuthWrapper heading="Password Reset Link Sent" subheading="A password reset link has been sent to your email. Please check your inbox and follow the instructions to reset your password.">
        <div className="max-w-md mx-auto mt-10">
          <div className="space-y-6">
            <Button loading={loading} onClick={navigateToLogin} variant="primary" fullWidth disabled={loading}>
              Back to Login
            </Button>
          </div>
        </div>
      </AuthWrapper>
    )
  }

  return (
    <AuthWrapper heading="Account Blocked" subheading="Account temporarily blocked after multiple failed login attempts. Use Forgot Password to unlock or contact your administrator.">
      <div className="max-w-md mx-auto mt-10">
        <div className="space-y-6">
          <Show when={email} >
            <Button loading={loading} onClick={handleResetPassword} variant="primary" fullWidth disabled={loading}>
              Reset Password
            </Button>
            <Show when={error}>
              <p className="max-w-sm font-semibold text-red-600 rounded-sm bg-primaryLightColorTwo">
                {error}
              </p>
            </Show>
          </Show>
          <button
            type="button"
            onClick={navigateToLogin}
            className="flex items-center justify-center w-full text-sm font-medium text-gray-600 transition-colors hover:text-primary-600"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Back to Login
          </button>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default AccountBlocked; 